import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/[...slug]/preview-wysiwyg.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/modules/layout/components/client-link/index.tsx");
